export default __webpack_public_path__ + "static/media/coffeeboy.84efb3a2.svg";